<template>
  <mdb-container class="gp-has-header">

    <data-table v-show="!showEditor" ref="campaignList" :add-handler="create"
                :click-handler="editCampaign"
                :columns="columns"
                add-label="New Campaign"
                data-source="/campaign/list"
                page-title="Ad Campaigns"
                show-add-button/>

    <div v-if="showEditor" class="text-left">
      <mdb-btn rounded size="sm" @click="showList">
        <mdb-icon icon="arrow-left"/>
        Back to List
      </mdb-btn>
      <mdb-input id="title" v-model="currentCampaign.title" label="Title"/>
      <mdb-input id="code" v-model="currentCampaign.code" label="Campaign Code" disabled/>
      <mdb-input id="url" v-model="currentCampaign.url" label="Campaign URL" disabled>
        <mdb-btn slot="append" icon="copy" size="sm" floating tag="a" @click="copyLink(currentCampaign.url)"/>
      </mdb-input>
      <mdb-input id="createdBy" v-model="currentCampaign.createdBy" label="Created By" disabled/>
      <mdb-input id="createdDate" v-model="currentCampaign.createdDate" label="Created On" disabled/>
      <mdb-btn :disabled="!currentCampaign.title"
               @click="save">
        <mdb-icon icon="save"/>
        Save
      </mdb-btn>

    </div>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import dataTable from "../common/DataTable";
import Vue from "vue";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';

export default {
  name: "ad-campaigns",
  display: "Ad Campaign",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileInput,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    dataTable,
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {

  },
  data() {
    return {
      campaigns: [],
      currentCampaign: {
        id: null, title: "", code: "", url: ""
      },
      showEditor: false,
      showViewer: false,

      columns: [
        {label: "Title", field: "title"},
        {label: "URL", field: "url"}
      ]
    }
  },
  methods: {
    async copyLink(url) {
      if (!navigator.clipboard) {
        this.$notify.error({message: "Your browser does not support copying to clipboard.", timeOut: 2500})
        return
      }
      try {
        await navigator.clipboard.writeText(url)
        this.$notify.success({message: "Link copied to clipboard.", timeOut: 2500})
      } catch (e) {
        this.$notify.error({message: "Error copying to clipboard." + e, timeOut: 2500})
      }
    },
    create: function () {
      this.currentCampaign = {
        url: "", title: "", code: ""
      }
      this.showEditor = true
      Vue.nextTick().then(() => {
        let el = document.getElementById("title")
        if (el) el.focus()
      })

    },
    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/campaign/settings", this.currentCampaign).then(
        (details) => {
          this.currentCampaign = details.data
          this.$notify.success({message: "Campaign saved successfully."})
        },
        (error) => {
          this.$notify.error({message: "Error saving campaign."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editCampaign: function (link) {
      this.currentCampaign = link
      this.showEditor = true
    },
    showList: function () {
      this.showEditor = false
      this.$store.dispatch("setDataTableReload", true)
    }
  }

}
;
</script>
